import {
  APEX_CHARTS_TYPES, AREA_CHART_DEFAULT_MAX_Y,
  CHART_LABEL_FONT_STYLE, CHART_LABEL_TWO_ROWS_FONT_STYLE,
  CHART_Y_AXIS_OFFSET, MAX_MOBILE_WIDTH
} from '@src/util/constants'

export function getAreaSplineChartOptions (categories, grid: any = {}, maxY: number = 0) {
  if (maxY < AREA_CHART_DEFAULT_MAX_Y) maxY = AREA_CHART_DEFAULT_MAX_Y
  let tickAmount
  let rotateAlways = false

  if (window.innerWidth < MAX_MOBILE_WIDTH) {
    tickAmount = 3
    rotateAlways = true
  }

  return {
    chart: {
      type: APEX_CHARTS_TYPES.AREA,
      height: '300',
      width: '100%',
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      },
      animations: {
        enabled: true
      }
    },
    grid: {
      ...grid
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: 1.5,
      curve: 'smooth'
    },
    legend: {
      show: false
    },
    tooltip: {
      onDatasetHover: {
        highlightDataSeries: true
      },
      shared: false,
      marker: {
        show: true
      }
    },
    yaxis: {
      opposite: true,
      forceNiceScale: false,
      min: (min) => min - CHART_Y_AXIS_OFFSET,
      max: maxY + CHART_Y_AXIS_OFFSET,
      tickAmount: maxY === 10 ? 5 : undefined,
      stepSize: maxY === 10 ? 2 + CHART_Y_AXIS_OFFSET : Math.floor(maxY / 3),
      labels: {
        style: { ...CHART_LABEL_FONT_STYLE.style },
        formatter: (val) => Math.abs(val.toFixed(0))
      }
    },
    xaxis: {
      type: 'numeric',
      overwriteCategories: categories,
      tickAmount,
      rotateAlways,
      tooltip: {
        enabled: false
      },
      labels: {
        style: CHART_LABEL_TWO_ROWS_FONT_STYLE
      }
    }
  }
}
